module.exports = __webpack_public_path__ + "assets/images/flashLiveErr4f2ff596.png";